import { DatePicker } from 'antd'
import { useState } from 'react'
import moment from 'moment'

export default DateInput = ({ initialValue, save, props... }) ->
  [value, setValue] = useState(initialValue)

  <DatePicker
    defaultValue={value}
    showTime={{ format: 'HH:mm' }}
    {...props}
  />
